import {debounce} from "lodash";

/*
 * 浏览器尺寸变化时回调
 */
export function useOnResize(onResize) {
    if (!onResize || typeof onResize != 'function') {
        return
    }
    const debouncedFunc = debounce(onResize, 250)

    // 页面resize处理
    function handleResizeEv() {
        debouncedFunc()
    }

    onMounted(() => {
        window.addEventListener("resize", handleResizeEv);
    });
    onBeforeUnmount(() => {
        window.removeEventListener("resize", handleResizeEv);
    });

    return {
    }
}
